<template>
    <div class="custom-page">
        <div class="block custom-block">
            <dl v-for="news in newsList"
                :key="news.newsId"
                @click="goDetail(news)"
            >
                <dt class="custom-text">{{isCn ? news.titleChina : news.titleEng}}</dt>
                <dd class="custom-photo">
                    <img :src="news.image" alt="">
                    <small>{{news.pubTime}}</small>
                </dd>
            </dl>
            <div class="more-row" v-show="isMore">
                <span class="btn-more" @click="showMore">{{lang.spread}}</span>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import { gDate } from '@/utils/format';
import router from '@/router';

export default {
    name: 'customListBlock',
    components: {
        Layout,
    },
    props: {
        pageId: Number,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            isMore: false,
            page: 1,
            newsList: [],
        };
    },
    mounted() {
        ajax.get('/web/news/news_list.json', {
            newsTypeId: this.$props.pageId,
            pageSize: 5,
            page: 1,
        }).then((result) => {
            this.page = 1;
            this.newsList = result.dataList.map((v) => {
                v.pubTime = gDate.datetimeFormat(v.pubTime, 'YYYY-MM-DD');
                return v;
            });
            if (result.totalPage > result.page) {
                this.isMore = true;
            }
        }).catch(() => {});
    },
    methods: {
        goDetail(news) {
            router.push({ name: 'newsDetail', params: { id: news.newsId } });
        },
        showMore() {
            this.isMore = false;
            ajax.get('/web/news/news_list.json', {
                newsTypeId: this.$props.pageId,
                pageSize: 5,
                page: this.page + 1,
            }).then((result) => {
                this.page = result.page;
                const nextList = result.dataList.map((v) => {
                    v.pubTime = gDate.datetimeFormat(v.pubTime, 'YYYY-MM-DD');
                    return v;
                });
                this.newsList = this.newsList.concat(nextList);
                if (result.totalPage > result.page) {
                    this.isMore = true;
                }
            }).catch(() => {});
        },
    },
};
</script>
<style lang="less" scoped>
    .block {
        margin-top: 10px;
        background: #fff;
        padding: 15px;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .custom-block {
        padding-top: 10px;
        .custom-text {
            margin-top: 10px;
            font-size: 13px;
            line-height: 20px;
            padding: 2px 0;
            word-break: break-word;
        }
        .custom-photo {
            padding-bottom: 12px;
            border-bottom: 1px solid #F1F1F1;
            width: 100%;
            img {
                display: block;
                width: 100%;
            }
            small {
                display: block;
                color: #9B9B9B;
                font-size: 12px;
                line-height: 16px;
            }
        }
    }
    .more-row {
        padding-top: 16px;
        text-align:center;
        .btn-more {
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 90px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
            color: #4A4A4A;
            border: 1px solid #C71F4B;
        }
    }
</style>
